// Variables
export const apiUrl = process.env.REACT_APP_API_URL;

export const apiPayoutUrl = process.env.REACT_APP_API_PAYOUT_URL;

export const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

export const enableReduxDevTools = process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS;
